// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { windowWhen } from "rxjs-compat/operator/windowWhen";

export const environment = {
  production: false,
  // apiUrl: "https://api.marketplace.cruzotec.com/",
  apiUrl: "https://fposervice.marketplace.cruzotec.com/",
  paymentApiUrl: "http://34.68.58.189:8080/",
  saasUrl: "https://saas-api.dev.cruzotec.com/",
 

 clientName : "fpo",
  projectName: "FPO",
  pageTitle: "FPO Admin",
  loginLogo: "assets/images/logoFPO.png",
  sidebarLogo: "assets/images/fposidelogo.png",
  navLogo: "assets/images/fpoNavLogo.png",

  sellerType: 'multi' ,// Single seller use "single" and Multi seller use "multi"
  //single Seller 
  // clientName : "marketplace" , //   "shg", // single seller -marketplace multi seller - shg 
  // projectName:  "Sambalpuri Bastralaya",   //  "SHG" ,
  // pageTitle:     "Sambalpuri Bastralaya Admin", //" SHG Admin",
  // loginLogo:      "assets/images/sblogo.png", // "assets/images/logoSHG.png",
  // sidebarLogo:    "assets/images/sbsidelogo.png",  // "assets/images/shgsidelogo.png",
  // navLogo:     "assets/images/sbNavLogo.png",   // "assets/images/shgNavLogo.png",
  CURRENCY: "INR",
  countryCode: "+91", //For mobile
  minLengthPhoneNumber: 5,
  maxLengthPhoneNumber: 16,
  phonePattern: /^[0-9]*$/,
  riderPhonePatern: /^[1-9]{1}[0-9]{6,17}$/,

  separator: " | ",
  showDevelopedBy: true,
  features: {
    couponNew: true,
    revenueAnalyticsNew: true,
    myAccountNew: false,
    riderEarningsNew: true,
    sellerEarningsNew: true,
    payoutRequestsNew: false,
    manualPayoutNew: true,
    companyProfileNew: false,
    fileUploadNew: false,
    importProductsNew: true,
    commission: true,
    faq: true,
    platformConfigNew: true,
    walletIncentives: true,
    banners: true,
    deleteCategory: true,
    deleteSellerReview: true,
    deleteOrderReview: true,
    deleteProductReview: true,
    deleteRider: true,
    notification: true,
    addSellerCatSorting: false,
    productAddUpdateFeature : true
  },
  forceLogout: true,
  firebase: {
    apiKey: "AIzaSyBb2cpJA6cvKhyjkj9ymCR3XMN8ovjklEw",
    authDomain: "cruzo-saas.firebaseapp.com",
    databaseURL: "https://cruzo-saas-default-rtdb.firebaseio.com",
    projectId: "cruzo-saas",
    storageBucket: "cruzo-saas.appspot.com",
    messagingSenderId: "203243497812",
    appId: "1:203243497812:web:ffc1085d2a38c1b83600c1",
    measurementId: "G-DWBES67CXL",
  },
  privacyConfig: {
    appName: "Cruzo",
    name: "Pharos Softtec Pvt. Ltd.",
    phone: "9558480559",
    logo: "",
    address: "Ramakirshna Sadan,Plot No-7,1st Floor, Ashok Nagar, Bhubaneswar",
    website: "https://cruzotec.com/",
    email: "connect@cruzotec.com",
    state: "Odisha",
  },
  serviceEnabled: {
    ecommercetest: true,
    "snigs-store": true,
    saahaaz: true,
    rred: true,
  },
  referralClients: ["vidyasaarthikart", "ecommercetest"],
  paymentSettings: true,
  mapKeys: ["AIzaSyD-TpbaeRkV8p7rNNQn9YBxrl4TKuTbbxE"],
  addonCategory: [
    {
      name: "AddOn",
      id: "add-on",
      addons: [],
    },
    {
      name: "Extras",
      id: "extras",
      addons: [],
    },
    {
      name: "Customs",
      id: "custom",
      addons: [],
    },
    {
      name: "Toppings",
      id: "toppings",
      addons: [],
    },
  ],
  productTypes: [
    {
      name: "none",
      id: "none",
      value: "None",
      class: "not-available",
    },
    {
      name: "veg",
      id: "veg",
      value: "Veg",
      class: "veg",
    },
    {
      name: "non-veg",
      id: "non-veg",
      value: "Non Veg",
      class: "non-veg",
    },
    {
      name: "egg",
      id: "egg",
      value: "Egg",
      class: "egg",
    },
    {
      name: "jain",
      id: "jain",
      value: "Jain",
      class: "jain",
    },
    {
      name : "others",
      id: "others",
      value : "Others",
      class : "others"
    }
  ],
   
};
